
















































import {Component, Prop} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import IntercomMixin from '@/components/helpers/intercom-mixin';
import Form from '@/components/form-base';

@Component
export default class HeaderButtons extends mixins(Form, IntercomMixin) {
  @Prop() 
  readArticleUrl: string;

  @Prop({ default: true }) 
  divider: boolean;

  menu: boolean = false;

  get items(): Bemob.ListItem[] {
    return [
      this.actions.readArticle,
      this.actions.openLiveSupport,
      this.actions.closeLiveSupport,
    ];
  }

  get actions() {
    return {
      readArticle: {
        key: 'read-article',
        title: this.t('Read Guide'),
        iconAppend: 'fas fa-question-circle',
        click: () => {},
        showCondition: !!this.readArticleUrl,
        href: this.readArticleUrl,
        target: '_blank',
        meta: {
          iconClass: 'dialog-form-title-buttons__icon',
          props: {
            href: this.readArticleUrl,
            target: '_blank'
          },
        }
      },
      openLiveSupport: {
        key: 'open-live-support',
        title: this.t('Live Support'),
        iconAppend: 'fas fa-comments',
        click: () => this.openLiveSupport(),
        showCondition: !this.isIntercomOpen,
        meta: {
          iconClass: 'dialog-form-title-buttons__icon',
        }
      },
      closeLiveSupport: {
        key: 'close-live-support',
        title: this.t('Close live chat'),
        iconAppend: 'fas fa-times', 
        click: () => this.closeLiveSupport(),
        showCondition: this.isIntercomOpen,
        meta: {
          iconClass: 'dialog-form-title-buttons__icon dialog-form-title-buttons__icon--close',
        }
      }
    };
  }

  get itemsFiltered() {
    return this.items.filter((item) => typeof item.showCondition === 'undefined' || item.showCondition);
  }

  handleAction() {
    this.menu = false;
  }
}
